import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Calendar, Shield } from 'lucide-react';

const ProtectionDonneesParieurs = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <main className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <article className="bg-gray-800 rounded-2xl p-8 md:p-12 border border-gray-700">
              <div className="flex items-center text-gray-400 text-sm mb-4">
                <Calendar size={16} className="mr-2" />
                <span>05.11.2025</span>
                <span className="mx-2">•</span>
                <span className="text-pink-400">Sécurité</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Protection des Données des Parieurs
              </h1>
              
              <div className="prose prose-invert max-w-none">
                <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                  Quand vous créez un compte sur un site de paris, vous confiez des informations personnelles et financières sensibles. Comprendre comment ces données sont protégées, quels sont vos droits, et quelles garanties vous offrent les sites licenciés est essentiel pour parier en toute confiance. Voici tout ce que vous devez savoir sur la protection de vos données sur les sites de paris français.
                </p>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">Les Obligations Légales des Sites</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Les sites de paris licenciés par l'ANJ sont soumis au RGPD (Règlement Général sur la Protection des Données), qui impose des standards stricts de protection. Vos données personnelles, financières, et de connexion doivent être chiffrées, sécurisées, et utilisées uniquement dans le cadre strict de l'activité de paris.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Les sites ne peuvent pas vendre vos données à des tiers, doivent vous informer clairement de leur utilisation, et doivent vous permettre de les supprimer sur demande. Ces obligations sont contrôlées par l'ANJ et peuvent entraîner des sanctions en cas de non-respect.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">Vos Droits en Tant que Parieur</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Vous avez le droit d'accéder à toutes vos données personnelles, de les corriger, de les supprimer, et de vous opposer à leur traitement. Les sites doivent répondre à ces demandes dans un délai raisonnable, généralement 30 jours maximum.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Vous pouvez également demander la portabilité de vos données si vous souhaitez changer de site. Cette flexibilité vous permet de migrer sans perdre votre historique, sous réserve de compatibilité technique entre les opérateurs.
                  </p>
                </section>
              </div>
            </article>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProtectionDonneesParieurs;

